export const transformPhoneNumber = (phoneNumber: string): string => {
    // Remove any non-digit character from the phone number
    const cleanedUpPhoneNumber = phoneNumber.replace(/[^\d]/g, "");

    if (cleanedUpPhoneNumber.length > 10) {
        // Add back the plus so we retain the country code supplied
        return `+${cleanedUpPhoneNumber}`;
    } else {
        // No country code was supplied so default to US country code
        return `+1${cleanedUpPhoneNumber}`;
    }
}